import React from "react";
import { useFeatures } from "../hooks/usePermissions";
import config from "../config";
import { formatPlanDate as fmt } from "../utils/features";

// Slim strip under the header for trial organizations: days left while the
// trial runs, and a read-only notice once it has ended. Hidden for standard
// plans, staff, and while entitlements are loading.
export default function TrialBanner() {
  const { plan, planEndsAt, planActive, daysLeft, isActive, staff, loading } = useFeatures();
  if (loading || staff) return null;

  let text = null;
  let tone = "#2f6b66";
  let bg = "#e3efed";
  if (isActive === false) {
    text = `This organization has been deactivated on EcoPrism. Contact ${config.supportEmail}.`;
    tone = "#8a1f1f"; bg = "#f9e3e3";
  } else if (plan === "trial") {
    if (planActive) {
      const when = fmt(planEndsAt);
      text = daysLeft != null
        ? `Trial · ${daysLeft} day${daysLeft === 1 ? "" : "s"} left${when ? ` (ends ${when})` : ""}`
        : "Trial";
      if (daysLeft != null && daysLeft <= 7) { tone = "#a34f10"; bg = "#fbe9dc"; }
    } else {
      text = `Your trial ended${planEndsAt ? ` on ${fmt(planEndsAt)}` : ""} — you can view your data but not change it. Contact ${config.supportEmail} to continue.`;
      tone = "#8a1f1f"; bg = "#f9e3e3";
    }
  }
  if (!text) return null;

  return (
    <div
      role="status"
      style={{
        background: bg,
        color: tone,
        borderBottom: `1px solid ${tone}33`,
        padding: "6px 24px",
        fontSize: 13,
        fontWeight: 500,
        textAlign: "center",
      }}
    >
      {text}
    </div>
  );
}
